// Code generated by csilgen. DO NOT EDIT.
// Source: <csil spec>
// Target: typescript-client

import type { ApproveCliLoginRequest, AuditPage, AuditQuery, BeginCliLoginRequest, BeginCliLoginResponse, BoolResponse, BugReportRequest, CalendarView, CliLoginRequestInfo, CliSessionsResponse, CliTokenResponse, Comment, CommentID, CommentListRequest, CompleteRequest, DenyCliLoginRequest, DependencyGraph, DependencyRef, DependencyTarget, DevLoginRequest, DevUsersResponse, EffectiveSettings, EmptyRequest, EmptyResponse, Event, EventID, EventListRequest, ExchangeCliLoginRequest, ExchangeCliLoginResponse, Grant, Group, GroupID, GroupMemberRef, GroupSkillRef, House, HouseID, HouseListRequest, HouseScopedListRequest, LoginRequest, LoginResponse, MeResponse, Member, MemberAudit, MemberID, MemberRoleRef, MemberScopedListRequest, MemberSkillRef, Milestone, MilestoneID, Notification, NotificationID, NotificationListRequest, NotificationUnreadCount, Project, ProjectGrantRef, ProjectID, ProjectList, ProjectMemberRef, ProjectOwnerRef, ProjectScopedListRequest, ProjectTaskOrderRequest, ProjectTaskRef, PurgeRequest, PutProjectGrantRequest, PutTaskGrantRequest, RefreshSessionRequest, ResourceRef, RestoreRequest, RevokeSessionRequest, Role, RoleID, SetProjectVisibilityRequest, SetTaskVisibilityRequest, Share, ShareAccessRequest, ShareID, Skill, SkillID, Task, TaskGrantRef, TaskID, TaskList, TaskListRequest, TrashPage, TrustedDomain, TrustedDomainID, UpdateSettingsRequest } from "./types.gen";
import { asArray, decode, encodeValue, fromAuditPageCbor, fromBeginCliLoginResponseCbor, fromBoolResponseCbor, fromCalendarViewCbor, fromCliLoginRequestInfoCbor, fromCliSessionsResponseCbor, fromCliTokenResponseCbor, fromCommentCbor, fromCommentCborValue, fromDependencyGraphCbor, fromDevUsersResponseCbor, fromEffectiveSettingsCbor, fromEmptyResponseCbor, fromEventCbor, fromEventCborValue, fromExchangeCliLoginResponseCbor, fromGrantCborValue, fromGroupCbor, fromGroupCborValue, fromHouseCbor, fromHouseCborValue, fromLoginResponseCbor, fromMeResponseCbor, fromMemberAuditCborValue, fromMemberCbor, fromMemberCborValue, fromMilestoneCbor, fromMilestoneCborValue, fromNotificationCbor, fromNotificationCborValue, fromNotificationUnreadCountCbor, fromProjectCbor, fromProjectListCbor, fromRoleCbor, fromRoleCborValue, fromShareCbor, fromShareCborValue, fromSkillCbor, fromSkillCborValue, fromTaskCbor, fromTaskListCbor, fromTrashPageCbor, fromTrustedDomainCbor, fromTrustedDomainCborValue, toApproveCliLoginRequestCbor, toAuditQueryCbor, toBeginCliLoginRequestCbor, toBugReportRequestCbor, toCalendarViewCbor, toCommentCbor, toCommentListRequestCbor, toCompleteRequestCbor, toDenyCliLoginRequestCbor, toDependencyRefCbor, toDependencyTargetCbor, toDevLoginRequestCbor, toEmptyRequestCbor, toEventCbor, toEventListRequestCbor, toExchangeCliLoginRequestCbor, toGroupCbor, toGroupMemberRefCbor, toGroupSkillRefCbor, toHouseCbor, toHouseListRequestCbor, toHouseScopedListRequestCbor, toLoginRequestCbor, toMemberCbor, toMemberRoleRefCbor, toMemberScopedListRequestCbor, toMemberSkillRefCbor, toMilestoneCbor, toNotificationListRequestCbor, toProjectCbor, toProjectGrantRefCbor, toProjectMemberRefCbor, toProjectOwnerRefCbor, toProjectScopedListRequestCbor, toProjectTaskOrderRequestCbor, toProjectTaskRefCbor, toPurgeRequestCbor, toPutProjectGrantRequestCbor, toPutTaskGrantRequestCbor, toRefreshSessionRequestCbor, toResourceRefCbor, toRestoreRequestCbor, toRevokeSessionRequestCbor, toRoleCbor, toSetProjectVisibilityRequestCbor, toSetTaskVisibilityRequestCbor, toShareAccessRequestCbor, toShareCbor, toSkillCbor, toTaskCbor, toTaskGrantRefCbor, toTaskListRequestCbor, toTrustedDomainCbor, toUpdateSettingsRequestCbor } from "./codec.gen";

export interface AsyncServiceTransport {
  call(service: string, op: string, req: Uint8Array): Promise<Uint8Array>;
}

export class AuditAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async queryAudit(req: AuditQuery): Promise<AuditPage> {
    const csilResp = await this.t.call("AuditService", "query-audit", toAuditQueryCbor(req));
    return fromAuditPageCbor(csilResp);
  }
}

export class AuthAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async login(req: LoginRequest): Promise<LoginResponse> {
    const csilResp = await this.t.call("AuthService", "login", toLoginRequestCbor(req));
    return fromLoginResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async complete(req: CompleteRequest): Promise<LoginResponse> {
    const csilResp = await this.t.call("AuthService", "complete", toCompleteRequestCbor(req));
    return fromLoginResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async refresh(req: EmptyRequest): Promise<LoginResponse> {
    const csilResp = await this.t.call("AuthService", "refresh", toEmptyRequestCbor(req));
    return fromLoginResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async logout(req: EmptyRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("AuthService", "logout", toEmptyRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async resumeSession(req: EmptyRequest): Promise<LoginResponse> {
    const csilResp = await this.t.call("AuthService", "resume-session", toEmptyRequestCbor(req));
    return fromLoginResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async endSession(req: EmptyRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("AuthService", "end-session", toEmptyRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async me(req: EmptyRequest): Promise<MeResponse> {
    const csilResp = await this.t.call("AuthService", "me", toEmptyRequestCbor(req));
    return fromMeResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async beginCliLogin(req: BeginCliLoginRequest): Promise<BeginCliLoginResponse> {
    const csilResp = await this.t.call("AuthService", "begin-cli-login", toBeginCliLoginRequestCbor(req));
    return fromBeginCliLoginResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async inspectCliLogin(req: ApproveCliLoginRequest): Promise<CliLoginRequestInfo> {
    const csilResp = await this.t.call("AuthService", "inspect-cli-login", toApproveCliLoginRequestCbor(req));
    return fromCliLoginRequestInfoCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async approveCliLogin(req: ApproveCliLoginRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("AuthService", "approve-cli-login", toApproveCliLoginRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async denyCliLogin(req: DenyCliLoginRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("AuthService", "deny-cli-login", toDenyCliLoginRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async exchangeCliLogin(req: ExchangeCliLoginRequest): Promise<ExchangeCliLoginResponse> {
    const csilResp = await this.t.call("AuthService", "exchange-cli-login", toExchangeCliLoginRequestCbor(req));
    return fromExchangeCliLoginResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async refreshSession(req: RefreshSessionRequest): Promise<CliTokenResponse> {
    const csilResp = await this.t.call("AuthService", "refresh-session", toRefreshSessionRequestCbor(req));
    return fromCliTokenResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listSessions(req: EmptyRequest): Promise<CliSessionsResponse> {
    const csilResp = await this.t.call("AuthService", "list-sessions", toEmptyRequestCbor(req));
    return fromCliSessionsResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async revokeSession(req: RevokeSessionRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("AuthService", "revoke-session", toRevokeSessionRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }
}

export class BugAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async reportBug(req: BugReportRequest): Promise<Task> {
    const csilResp = await this.t.call("BugService", "report-bug", toBugReportRequestCbor(req));
    return fromTaskCbor(csilResp);
  }
}

export class CommentAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createComment(req: Comment): Promise<Comment> {
    const csilResp = await this.t.call("CommentService", "create-comment", toCommentCbor(req));
    return fromCommentCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async getComment(req: CommentID): Promise<Comment> {
    const csilResp = await this.t.call("CommentService", "get-comment", encodeValue(req));
    return fromCommentCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateComment(req: Comment): Promise<Comment> {
    const csilResp = await this.t.call("CommentService", "update-comment", toCommentCbor(req));
    return fromCommentCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteComment(req: CommentID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("CommentService", "delete-comment", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listComments(req: CommentListRequest): Promise<Comment[]> {
    const csilResp = await this.t.call("CommentService", "list-comments", toCommentListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromCommentCborValue(csilE));
  }
}

export class DependencyAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async addDependency(req: DependencyRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("DependencyService", "add-dependency", toDependencyRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async removeDependency(req: DependencyRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("DependencyService", "remove-dependency", toDependencyRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async getDependencies(req: DependencyTarget): Promise<DependencyGraph> {
    const csilResp = await this.t.call("DependencyService", "get-dependencies", toDependencyTargetCbor(req));
    return fromDependencyGraphCbor(csilResp);
  }
}

export class DevAuthAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listDevUsers(req: EmptyRequest): Promise<DevUsersResponse> {
    const csilResp = await this.t.call("DevAuthService", "list-dev-users", toEmptyRequestCbor(req));
    return fromDevUsersResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async devLogin(req: DevLoginRequest): Promise<LoginResponse> {
    const csilResp = await this.t.call("DevAuthService", "dev-login", toDevLoginRequestCbor(req));
    return fromLoginResponseCbor(csilResp);
  }
}

export class EventAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createEvent(req: Event): Promise<Event> {
    const csilResp = await this.t.call("EventService", "create-event", toEventCbor(req));
    return fromEventCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async getEvent(req: EventID): Promise<Event> {
    const csilResp = await this.t.call("EventService", "get-event", encodeValue(req));
    return fromEventCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateEvent(req: Event): Promise<Event> {
    const csilResp = await this.t.call("EventService", "update-event", toEventCbor(req));
    return fromEventCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteEvent(req: EventID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("EventService", "delete-event", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteEventAndFuture(req: EventID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("EventService", "delete-event-and-future", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listEvents(req: EventListRequest): Promise<Event[]> {
    const csilResp = await this.t.call("EventService", "list-events", toEventListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromEventCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async getCalendarView(req: HouseID): Promise<CalendarView> {
    const csilResp = await this.t.call("EventService", "get-calendar-view", encodeValue(req));
    return fromCalendarViewCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async setCalendarView(req: CalendarView): Promise<CalendarView> {
    const csilResp = await this.t.call("EventService", "set-calendar-view", toCalendarViewCbor(req));
    return fromCalendarViewCbor(csilResp);
  }
}

export class GroupAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createGroup(req: Group): Promise<Group> {
    const csilResp = await this.t.call("GroupService", "create-group", toGroupCbor(req));
    return fromGroupCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateGroup(req: Group): Promise<Group> {
    const csilResp = await this.t.call("GroupService", "update-group", toGroupCbor(req));
    return fromGroupCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteGroup(req: GroupID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("GroupService", "delete-group", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listGroups(req: HouseScopedListRequest): Promise<Group[]> {
    const csilResp = await this.t.call("GroupService", "list-groups", toHouseScopedListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromGroupCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async addGroupMember(req: GroupMemberRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("GroupService", "add-group-member", toGroupMemberRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async removeGroupMember(req: GroupMemberRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("GroupService", "remove-group-member", toGroupMemberRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listGroupMembers(req: MemberScopedListRequest): Promise<Member[]> {
    const csilResp = await this.t.call("GroupService", "list-group-members", toMemberScopedListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromMemberCborValue(csilE));
  }
}

export class HouseAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createHouse(req: House): Promise<House> {
    const csilResp = await this.t.call("HouseService", "create-house", toHouseCbor(req));
    return fromHouseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async getHouse(req: HouseID): Promise<House> {
    const csilResp = await this.t.call("HouseService", "get-house", encodeValue(req));
    return fromHouseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateHouse(req: House): Promise<House> {
    const csilResp = await this.t.call("HouseService", "update-house", toHouseCbor(req));
    return fromHouseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteHouse(req: HouseID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("HouseService", "delete-house", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listHouses(req: HouseListRequest): Promise<House[]> {
    const csilResp = await this.t.call("HouseService", "list-houses", toHouseListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromHouseCborValue(csilE));
  }
}

export class MemberAuditAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listAuditsForMember(req: MemberScopedListRequest): Promise<MemberAudit[]> {
    const csilResp = await this.t.call("MemberAuditService", "list-audits-for-member", toMemberScopedListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromMemberAuditCborValue(csilE));
  }
}

export class MemberAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createMember(req: Member): Promise<Member> {
    const csilResp = await this.t.call("MemberService", "create-member", toMemberCbor(req));
    return fromMemberCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async getMember(req: MemberID): Promise<Member> {
    const csilResp = await this.t.call("MemberService", "get-member", encodeValue(req));
    return fromMemberCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async getMemberByIdentity(req: Member): Promise<Member> {
    const csilResp = await this.t.call("MemberService", "get-member-by-identity", toMemberCbor(req));
    return fromMemberCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateMember(req: Member): Promise<Member> {
    const csilResp = await this.t.call("MemberService", "update-member", toMemberCbor(req));
    return fromMemberCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deactivateMember(req: MemberID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("MemberService", "deactivate-member", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async reactivateMember(req: MemberID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("MemberService", "reactivate-member", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listMembers(req: HouseScopedListRequest): Promise<Member[]> {
    const csilResp = await this.t.call("MemberService", "list-members", toHouseScopedListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromMemberCborValue(csilE));
  }
}

export class NotificationAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listNotifications(req: NotificationListRequest): Promise<Notification[]> {
    const csilResp = await this.t.call("NotificationService", "list-notifications", toNotificationListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromNotificationCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async unreadCount(req: HouseID): Promise<NotificationUnreadCount> {
    const csilResp = await this.t.call("NotificationService", "unread-count", encodeValue(req));
    return fromNotificationUnreadCountCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async markRead(req: NotificationID): Promise<Notification> {
    const csilResp = await this.t.call("NotificationService", "mark-read", encodeValue(req));
    return fromNotificationCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async markAllRead(req: HouseID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("NotificationService", "mark-all-read", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }
}

export class ProjectAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createProject(req: Project): Promise<Project> {
    const csilResp = await this.t.call("ProjectService", "create-project", toProjectCbor(req));
    return fromProjectCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async getProject(req: ProjectID): Promise<Project> {
    const csilResp = await this.t.call("ProjectService", "get-project", encodeValue(req));
    return fromProjectCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateProject(req: Project): Promise<Project> {
    const csilResp = await this.t.call("ProjectService", "update-project", toProjectCbor(req));
    return fromProjectCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteProject(req: ProjectID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "delete-project", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listProjects(req: HouseScopedListRequest): Promise<ProjectList> {
    const csilResp = await this.t.call("ProjectService", "list-projects", toHouseScopedListRequestCbor(req));
    return fromProjectListCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listProjectTasks(req: ProjectScopedListRequest): Promise<TaskList> {
    const csilResp = await this.t.call("ProjectService", "list-project-tasks", toProjectScopedListRequestCbor(req));
    return fromTaskListCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async addProjectTask(req: ProjectTaskOrderRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "add-project-task", toProjectTaskOrderRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async removeProjectTask(req: ProjectTaskRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "remove-project-task", toProjectTaskRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async setProjectTaskPosition(req: ProjectTaskOrderRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "set-project-task-position", toProjectTaskOrderRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listProjectMembers(req: ProjectID): Promise<Member[]> {
    const csilResp = await this.t.call("ProjectService", "list-project-members", encodeValue(req));
    return asArray(decode(csilResp)).map((csilE) => fromMemberCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async addProjectMember(req: ProjectMemberRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "add-project-member", toProjectMemberRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async removeProjectMember(req: ProjectMemberRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "remove-project-member", toProjectMemberRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listProjectOwners(req: ProjectID): Promise<Member[]> {
    const csilResp = await this.t.call("ProjectService", "list-project-owners", encodeValue(req));
    return asArray(decode(csilResp)).map((csilE) => fromMemberCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async addProjectOwner(req: ProjectOwnerRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "add-project-owner", toProjectOwnerRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async removeProjectOwner(req: ProjectOwnerRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "remove-project-owner", toProjectOwnerRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listMilestones(req: ProjectID): Promise<Milestone[]> {
    const csilResp = await this.t.call("ProjectService", "list-milestones", encodeValue(req));
    return asArray(decode(csilResp)).map((csilE) => fromMilestoneCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createMilestone(req: Milestone): Promise<Milestone> {
    const csilResp = await this.t.call("ProjectService", "create-milestone", toMilestoneCbor(req));
    return fromMilestoneCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateMilestone(req: Milestone): Promise<Milestone> {
    const csilResp = await this.t.call("ProjectService", "update-milestone", toMilestoneCbor(req));
    return fromMilestoneCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteMilestone(req: MilestoneID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "delete-milestone", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async setProjectVisibility(req: SetProjectVisibilityRequest): Promise<Project> {
    const csilResp = await this.t.call("ProjectService", "set-project-visibility", toSetProjectVisibilityRequestCbor(req));
    return fromProjectCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listProjectGrants(req: ProjectID): Promise<Grant[]> {
    const csilResp = await this.t.call("ProjectService", "list-project-grants", encodeValue(req));
    return asArray(decode(csilResp)).map((csilE) => fromGrantCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async putProjectGrant(req: PutProjectGrantRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "put-project-grant", toPutProjectGrantRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteProjectGrant(req: ProjectGrantRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ProjectService", "delete-project-grant", toProjectGrantRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }
}

export class RoleAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createRole(req: Role): Promise<Role> {
    const csilResp = await this.t.call("RoleService", "create-role", toRoleCbor(req));
    return fromRoleCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateRole(req: Role): Promise<Role> {
    const csilResp = await this.t.call("RoleService", "update-role", toRoleCbor(req));
    return fromRoleCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteRole(req: RoleID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("RoleService", "delete-role", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listRoles(req: HouseScopedListRequest): Promise<Role[]> {
    const csilResp = await this.t.call("RoleService", "list-roles", toHouseScopedListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromRoleCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async grantRole(req: MemberRoleRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("RoleService", "grant-role", toMemberRoleRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async revokeRole(req: MemberRoleRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("RoleService", "revoke-role", toMemberRoleRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listMemberRoles(req: MemberScopedListRequest): Promise<Role[]> {
    const csilResp = await this.t.call("RoleService", "list-member-roles", toMemberScopedListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromRoleCborValue(csilE));
  }
}

export class SettingsAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async getSettings(req: HouseID): Promise<EffectiveSettings> {
    const csilResp = await this.t.call("SettingsService", "get-settings", encodeValue(req));
    return fromEffectiveSettingsCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateSettings(req: UpdateSettingsRequest): Promise<EffectiveSettings> {
    const csilResp = await this.t.call("SettingsService", "update-settings", toUpdateSettingsRequestCbor(req));
    return fromEffectiveSettingsCbor(csilResp);
  }
}

export class ShareAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createShare(req: Share): Promise<Share> {
    const csilResp = await this.t.call("ShareService", "create-share", toShareCbor(req));
    return fromShareCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteShare(req: ShareID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("ShareService", "delete-share", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listSharesByResource(req: ResourceRef): Promise<Share[]> {
    const csilResp = await this.t.call("ShareService", "list-shares-by-resource", toResourceRefCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromShareCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async checkAccess(req: ShareAccessRequest): Promise<Share> {
    const csilResp = await this.t.call("ShareService", "check-access", toShareAccessRequestCbor(req));
    return fromShareCbor(csilResp);
  }
}

export class SkillAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createSkill(req: Skill): Promise<Skill> {
    const csilResp = await this.t.call("SkillService", "create-skill", toSkillCbor(req));
    return fromSkillCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateSkill(req: Skill): Promise<Skill> {
    const csilResp = await this.t.call("SkillService", "update-skill", toSkillCbor(req));
    return fromSkillCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteSkill(req: SkillID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("SkillService", "delete-skill", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listSkills(req: HouseScopedListRequest): Promise<Skill[]> {
    const csilResp = await this.t.call("SkillService", "list-skills", toHouseScopedListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromSkillCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async addMemberSkill(req: MemberSkillRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("SkillService", "add-member-skill", toMemberSkillRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async removeMemberSkill(req: MemberSkillRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("SkillService", "remove-member-skill", toMemberSkillRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listMemberSkills(req: MemberScopedListRequest): Promise<Skill[]> {
    const csilResp = await this.t.call("SkillService", "list-member-skills", toMemberScopedListRequestCbor(req));
    return asArray(decode(csilResp)).map((csilE) => fromSkillCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async addGroupSkill(req: GroupSkillRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("SkillService", "add-group-skill", toGroupSkillRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async removeGroupSkill(req: GroupSkillRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("SkillService", "remove-group-skill", toGroupSkillRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listGroupSkills(req: GroupID): Promise<Skill[]> {
    const csilResp = await this.t.call("SkillService", "list-group-skills", encodeValue(req));
    return asArray(decode(csilResp)).map((csilE) => fromSkillCborValue(csilE));
  }
}

export class TaskAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createTask(req: Task): Promise<Task> {
    const csilResp = await this.t.call("TaskService", "create-task", toTaskCbor(req));
    return fromTaskCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async getTask(req: TaskID): Promise<Task> {
    const csilResp = await this.t.call("TaskService", "get-task", encodeValue(req));
    return fromTaskCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async updateTask(req: Task): Promise<Task> {
    const csilResp = await this.t.call("TaskService", "update-task", toTaskCbor(req));
    return fromTaskCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteTask(req: TaskID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("TaskService", "delete-task", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listTasks(req: TaskListRequest): Promise<TaskList> {
    const csilResp = await this.t.call("TaskService", "list-tasks", toTaskListRequestCbor(req));
    return fromTaskListCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async createPersonalTask(req: Task): Promise<Task> {
    const csilResp = await this.t.call("TaskService", "create-personal-task", toTaskCbor(req));
    return fromTaskCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async setTaskVisibility(req: SetTaskVisibilityRequest): Promise<Task> {
    const csilResp = await this.t.call("TaskService", "set-task-visibility", toSetTaskVisibilityRequestCbor(req));
    return fromTaskCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listTaskGrants(req: TaskID): Promise<Grant[]> {
    const csilResp = await this.t.call("TaskService", "list-task-grants", encodeValue(req));
    return asArray(decode(csilResp)).map((csilE) => fromGrantCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async putTaskGrant(req: PutTaskGrantRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("TaskService", "put-task-grant", toPutTaskGrantRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async deleteTaskGrant(req: TaskGrantRef): Promise<EmptyResponse> {
    const csilResp = await this.t.call("TaskService", "delete-task-grant", toTaskGrantRefCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }
}

export class TrashAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listTrash(req: HouseScopedListRequest): Promise<TrashPage> {
    const csilResp = await this.t.call("TrashService", "list-trash", toHouseScopedListRequestCbor(req));
    return fromTrashPageCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async restore(req: RestoreRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("TrashService", "restore", toRestoreRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async purge(req: PurgeRequest): Promise<EmptyResponse> {
    const csilResp = await this.t.call("TrashService", "purge", toPurgeRequestCbor(req));
    return fromEmptyResponseCbor(csilResp);
  }
}

export class TrustedDomainAsyncClient {
  constructor(private readonly t: AsyncServiceTransport) {}

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async addTrustedDomain(req: TrustedDomain): Promise<TrustedDomain> {
    const csilResp = await this.t.call("TrustedDomainService", "add-trusted-domain", toTrustedDomainCbor(req));
    return fromTrustedDomainCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async removeTrustedDomain(req: TrustedDomainID): Promise<EmptyResponse> {
    const csilResp = await this.t.call("TrustedDomainService", "remove-trusted-domain", encodeValue(req));
    return fromEmptyResponseCbor(csilResp);
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async listTrustedDomains(req: HouseID): Promise<TrustedDomain[]> {
    const csilResp = await this.t.call("TrustedDomainService", "list-trusted-domains", encodeValue(req));
    return asArray(decode(csilResp)).map((csilE) => fromTrustedDomainCborValue(csilE));
  }

  /**
   * @throws {ServiceError} when the API returns an error response
   * @throws transport errors (network, timeout) raised by the transport
   */
  async isDomainTrusted(req: TrustedDomain): Promise<BoolResponse> {
    const csilResp = await this.t.call("TrustedDomainService", "is-domain-trusted", toTrustedDomainCbor(req));
    return fromBoolResponseCbor(csilResp);
  }
}

export class AsyncApiClient {
  readonly audit: AuditAsyncClient;
  readonly auth: AuthAsyncClient;
  readonly bug: BugAsyncClient;
  readonly comment: CommentAsyncClient;
  readonly dependency: DependencyAsyncClient;
  readonly devAuth: DevAuthAsyncClient;
  readonly event: EventAsyncClient;
  readonly group: GroupAsyncClient;
  readonly house: HouseAsyncClient;
  readonly memberAudit: MemberAuditAsyncClient;
  readonly member: MemberAsyncClient;
  readonly notification: NotificationAsyncClient;
  readonly project: ProjectAsyncClient;
  readonly role: RoleAsyncClient;
  readonly settings: SettingsAsyncClient;
  readonly share: ShareAsyncClient;
  readonly skill: SkillAsyncClient;
  readonly task: TaskAsyncClient;
  readonly trash: TrashAsyncClient;
  readonly trustedDomain: TrustedDomainAsyncClient;
  constructor(t: AsyncServiceTransport) {
    this.audit = new AuditAsyncClient(t);
    this.auth = new AuthAsyncClient(t);
    this.bug = new BugAsyncClient(t);
    this.comment = new CommentAsyncClient(t);
    this.dependency = new DependencyAsyncClient(t);
    this.devAuth = new DevAuthAsyncClient(t);
    this.event = new EventAsyncClient(t);
    this.group = new GroupAsyncClient(t);
    this.house = new HouseAsyncClient(t);
    this.memberAudit = new MemberAuditAsyncClient(t);
    this.member = new MemberAsyncClient(t);
    this.notification = new NotificationAsyncClient(t);
    this.project = new ProjectAsyncClient(t);
    this.role = new RoleAsyncClient(t);
    this.settings = new SettingsAsyncClient(t);
    this.share = new ShareAsyncClient(t);
    this.skill = new SkillAsyncClient(t);
    this.task = new TaskAsyncClient(t);
    this.trash = new TrashAsyncClient(t);
    this.trustedDomain = new TrustedDomainAsyncClient(t);
  }
}
